<template>
  <el-container>
    <el-main class="main" :style="{'min-height': height, 'padding': 0}" v-if="!isIframe">
      <nuxt/>
    </el-main>
    <template v-else>
      <nuxt/>
    </template>
  </el-container>
</template>

<script>
  import {ding_erformance} from "./js/entConsoleDate.js"
  import TimerUp from "../components/timer-up/index";
  export default {
    components: {TimerUp},
    data() {
      return {
        height: '700px',
        isIframe: false,
      };
    },
    mounted() {
      this.height = (document.body.clientHeight) + 'px';
      this.isIframe = window !== window.top;
      ding_erformance()
    },
    name: "user"
  }
</script>

<style lang="less" scoped>
  .main {
    display: flex;
    flex-direction: column;
    background: url("/images/login_bg.jpg") no-repeat;
    background-size: cover;
  }

  .header {
    max-width: 1200px;
    margin: 0 auto;
    height: 30px;

    nav {
      width: 100%;
      overflow: hidden;
      height: 30px;
      text-align: right;
      ul li {
        display: inline-block;
        text-align: right;
        .item {
          display: inline-block;
          width: 70px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
        }
      }
      li.active .item {
        background: #ec1c1c;
      }
    }
    .countdown {
      line-height: 30px;
      height: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// layouts/user.vue